import { SortAndFilterModel } from './filter-types';

/**
 * Adds or removes the updatedOption value from a filterType's current value.
 *
 * @param {string[] | string} currentValue - The filterType's current value.
 * @param {string} updatedOption - The value of the option that has been updated.
 * @returns {string[] | string} - The updated value, eg. ['FREE_BREAKFAST', 'HOT_TUB'] or 'FREE_BREAKFAST'
 */
export const updateFilterTypeValue = (currentValue: string[] | string, updatedOption: string): string[] | string => {
  let newValue = currentValue;
  if (newValue.includes(updatedOption)) {
    newValue = Array.isArray(newValue) ? newValue.filter(o => o !== updatedOption) : ''; // Remove value
  } else {
    Array.isArray(newValue) ? newValue.push(updatedOption) : (newValue = updatedOption); // Add value
  }

  return newValue;
};

/**
 * Returns an array of filterTypes that contain a given option.
 * Note: popularFilter works differently and not really a filterType, so we want to exclude it.
 *
 * @param {SortAndFilterModel} sortAndFilterOptions - The list of filter types to check for the option.
 * @param {string} optionValue - The option to check for.
 * @returns {string[]} - The list of filterTypes that contain the given option.
 */
export const getFilterTypesWithOption = (sortAndFilterOptions: SortAndFilterModel, optionValue: string): string[] => {
  const filterTypes = [];
  Object.entries(sortAndFilterOptions).forEach(([key, value]) => {
    if (key !== 'popularFilter' && value.options?.some(o => o.value === optionValue)) {
      filterTypes.push(key);
    }
  });

  return filterTypes;
};

/**
 * Returns an array from the given value.
 *
 * @param {string[] | string} value - The value to convert to an array.
 * @returns {string[]} - The resulting array.
 */
export const getValueArray = (value: string | string[]): string[] => (typeof value === 'string' ? value.split(',') : value.slice());
